import { Navigate } from 'react-router'
import { useAuth } from '../shared/auth'
import type { ReactNode } from 'react'
import { APP_ROUTES } from './routes.constants'

interface ProtectedRouteProps {
  children: ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to={APP_ROUTES.HOME} replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
